const desktop = theme => {
  const {toVW} = theme;

  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    iconButton: {fontSize: 14, color: '#CCCCCC', cursor: 'pointer'},
    extendTimerContainer: {
      width: '200px',
      height: '260px',
      borderRadius: 10,
      top: 40,
      background:
        'linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #202633',
      padding: '15px',
      position: 'absolute',
      transform: 'translateX(-100%)',
      zIndex: 10,
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10)',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 13,
      zIndex: 10,
    },
    antdForm: {
      color: 'white',
      '& .ant-form-item': {
        marginBottom: '10px',
        width: '100%',
      },
    },
    timeRow: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    },
    diamondRow: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    diamondImage: {
      height: 22,
      width: 24,
      marginRight: 5,
    },
    customSelect: {
      borderRadius: 10,
      color: 'white',
      padding: 0,
      background: '#202633',
      '& .ant-select-item-option-content': {
        color: 'white !important',
      },
      '& .ant-select-arrow': {
        color: 'white',
      },
    },
    customDropdown: {
      borderRadius: 10,
      padding: 0,
      background: '#202633',
      '& .ant-select-item-option-selected:not(.ant-select-item-option-disabled)': {
        backgroundColor: 'transparent',
      },
      '& .ant-select-item-option-active:not(.ant-select-item-option-disabled)': {
        backgroundColor: 'transparent',
        fontWeight: 400,
      },
      '& .ant-select-item': {
        color: 'white',
      },
      '& .ant-select-item-option:hover ': {
        backgroundColor: 'transparent',
      },
    },
    hidden: {
      visibility: 'hidden',
      opacity: 0,
    },
    extendTimerText: {
      whiteSpace: 'nowrap',
      position: 'absolute',
      top: '50px',
      right: '10px',
      textAlign: 'end',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      cursor: 'pointer',
    },
    warning: {
      color: 'red',
    },
    diamondNeeded: {
      color: 'white',
    },
    messageRow: {
      width: '100%',
      textAlign: 'right',
      color: 'red',
      minHeight: '21px',
    },
    messageRowHidden: {
      visibility: 'hidden',
      minHeight: '21px',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
